import { useEffect, useState, type MouseEvent } from "react";

/** Минимальный роутер на History API: проект пока обходится без лишних зависимостей. */

/** Вкладка Grabit MOEX: прогноз ДеМарка и позиции FUTOI (/grabit). */
export function isGrabitRoute(route: Route): boolean {
  return route.name === "grabit";
}

/** Раздел США: страницы /us, /us/trades, /us/backtest и рынки /us/{код}. */
export function isUsRoute(route: Route): boolean {
  return route.name === "us" || route.name === "usMarket" || route.name === "usTrades" || route.name === "usBacktest";
}
export type Route =
  | { name: "scanner" }
  | { name: "market"; code: string }
  | { name: "journal" }
  | { name: "backtest" }
  | { name: "trades" }
  | { name: "settings" }
  | { name: "us" }
  | { name: "usTrades" }
  | { name: "usBacktest" }
  | { name: "usMarket"; code: string }
  | { name: "grabit" }
  | { name: "login" }
  | { name: "account" };

export function parse(path: string): Route {
  const parts = path.replace(/\/+$/, "").split("/").filter(Boolean);
  if (parts[0] === "us" && parts[1] === "trades") return { name: "usTrades" };
  if (parts[0] === "us" && parts[1] === "backtest") return { name: "usBacktest" };
  if (parts[0] === "us" && parts[1]) return { name: "usMarket", code: decodeURIComponent(parts[1]) };
  if (parts[0] === "us") return { name: "us" };
  if (parts[0] === "grabit") return { name: "grabit" };
  if (parts[0] === "login") return { name: "login" };
  if (parts[0] === "account") return { name: "account" };
  if (parts[0] === "settings") return { name: "settings" };
  if (parts[0] === "ru" && parts[1] === "journal") return { name: "journal" };
  if (parts[0] === "ru" && parts[1] === "backtest") return { name: "backtest" };
  if (parts[0] === "ru" && parts[1] === "trades") return { name: "trades" };
  if (parts[0] === "ru" && parts[1]) return { name: "market", code: decodeURIComponent(parts[1]) };
  return { name: "scanner" };
}

export function navigate(to: string) {
  if (to === window.location.pathname + window.location.search) return;
  window.history.pushState(null, "", to);
  window.dispatchEvent(new PopStateEvent("popstate"));
  window.scrollTo({ top: 0 });
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parse(window.location.pathname));
  useEffect(() => {
    const on = () => setRoute(parse(window.location.pathname));
    window.addEventListener("popstate", on);
    return () => window.removeEventListener("popstate", on);
  }, []);
  return route;
}

/** Обработчик клика по ссылке: внутренняя навигация без перезагрузки, Ctrl/Cmd-клик — как обычно. */
export function linkHandler(to: string) {
  return (e: MouseEvent) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    navigate(to);
  };
}
